import apiService from './apiService';
import { AxiosRequestConfig } from 'axios';

export interface AuditTrail {
  id: number;
  client_id: number;
  user_id?: number | null;
  session_id?: string | null;
  area: string;
  entity_type: string;
  entity_id: string;
  action: string;
  change_date: string;
  old_data?: Record<string, any> | null;
  new_data?: Record<string, any> | null;
  reason?: string | null;
  source_system?: string | null;
  ip_address?: string | null;
  user_agent?: string | null;
  audit_metadata?: Record<string, any> | null;
  created_at: string;
  client_name?: string | null;
  user_name?: string | null;
}

export interface AuditTrailListResponse {
  audit_trails: AuditTrail[];
  total_count: number;
  page: number;
  limit: number;
}

export interface AuditTrailFilters {
  client_id: number;
  start_date?: string;
  end_date?: string;
  area?: string;
  entity_type?: string;
  action?: string;
  source_system?: string;
  limit?: number;
  skip?: number;
}

class AuditTrailService {
  async getAuditTrails(
    filters: AuditTrailFilters,
    options?: AxiosRequestConfig
  ): Promise<AuditTrailListResponse> {
    try {
      const response = await apiService.get<AuditTrailListResponse>('/api/audit-trail', {
        params: filters,
        ...options
      });
      return response.data;
    } catch (error) {
      console.error('AuditTrailService - Error fetching audit trails:', error);
      throw error;
    }
  }

  async getAuditTrail(
    auditTrailId: number,
    config?: AxiosRequestConfig
  ): Promise<AuditTrail> {
    try {
      const response = await apiService.get<AuditTrail>(`/api/audit-trail/${auditTrailId}`, config);
      return response.data;
    } catch (error) {
      console.error('AuditTrailService - Error fetching audit trail:', error);
      throw error;
    }
  }

  async getAuditAreas(
    clientId: number,
    config?: AxiosRequestConfig
  ): Promise<string[]> {
    try {
      const response = await apiService.get<string[]>('/api/audit-trail/areas/list', {
        params: { client_id: clientId },
        ...config
      });
      return response.data;
    } catch (error) {
      console.error('AuditTrailService - Error fetching audit areas:', error);
      throw error;
    }
  }

  async getAuditEntityTypes(
    clientId: number,
    config?: AxiosRequestConfig
  ): Promise<string[]> {
    try {
      const response = await apiService.get<string[]>('/api/audit-trail/entity-types/list', {
        params: { client_id: clientId },
        ...config
      });
      return response.data;
    } catch (error) {
      console.error('AuditTrailService - Error fetching audit entity types:', error);
      throw error;
    }
  }

  async getAuditActions(
    clientId: number,
    config?: AxiosRequestConfig
  ): Promise<string[]> {
    try {
      const response = await apiService.get<string[]>('/api/audit-trail/actions/list', {
        params: { client_id: clientId },
        ...config
      });
      return response.data;
    } catch (error) {
      console.error('AuditTrailService - Error fetching audit actions:', error);
      throw error;
    }
  }
}

export default new AuditTrailService();